import { render, staticRenderFns } from "./emplooye-task-add.html?vue&type=template&id=4dc38999&scoped=true&external"
import script from "./emplooye-task-add.js?vue&type=script&lang=js&external"
export * from "./emplooye-task-add.js?vue&type=script&lang=js&external"
import style0 from "./emplooye-task-add.scss?vue&type=style&index=0&id=4dc38999&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc38999",
  null
  
)

export default component.exports